import IMessageTranslator from './IMessageTranslator.js';
import {TranslationsEntry} from './TranslationsEntry.js';

function lookupClosest(localeId: string, translations: TranslationsEntry[]): TranslationsEntry {
    let name = localeId.toLowerCase();
    while (true) {
        let entry = translations.find((x) => x.localeId.toLowerCase() === localeId);
        if (entry != null) {
            return entry;
        }
        let dash = name.lastIndexOf("-");
        if (dash === -1) {
            return translations[0];
        }
        name = name.substring(0, dash);
    }
}

class Translations implements IMessageTranslator {
    private readonly _translations: Record<string, string>;

    constructor(localeId: string, translations: TranslationsEntry[]) {
        this._translations = lookupClosest(localeId, translations).translations;
    }

    get(key: string): string {
        return this._translations[key] || key;
    }
}

export {Translations};
